import {createAnnotation} from './utils/createAnnotation'

/**
 * The annotation builder for the form property describing the type of form tooltip.
 */
export const tooltipType = createAnnotation('tooltipType').typed('string')
